var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row retroactive-payments" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "col-12 mt-2" },
        [
          _c("div", { staticClass: "retroactive-payments__question" }, [
            _vm._v(" ¿La consulta tiene autorizado pagos retroactivos? ")
          ]),
          _c("custom-radio", {
            staticClass: "w-75 retroactive-payments__radio",
            attrs: {
              "custom-error-msg": "Favor marque sí o no.",
              disabled: "",
              "is-inline": "",
              name: "hasRetroactivePaymentAuthorization",
              options: _vm.yesNoOptions
            },
            model: {
              value: _vm.selectedRetroactivePaymentAuthorization,
              callback: function($$v) {
                _vm.selectedRetroactivePaymentAuthorization = $$v
              },
              expression: "selectedRetroactivePaymentAuthorization"
            }
          })
        ],
        1
      ),
      _vm.hasRetroactivePaymentAuthorization === true
        ? [
            _c("div", { staticClass: "col-12 mt-2" }, [
              _c("div", { staticClass: "retroactive-payments__label" }, [
                _vm._v(" Justificación de pago retroactivo: ")
              ]),
              _c("div", { staticClass: "retroactive-payments__text" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.model.retroactivePaymentJustification || "-") +
                    " "
                )
              ])
            ]),
            _c(
              "div",
              { staticClass: "col-12 mt-3" },
              [
                _vm._m(1),
                !_vm.retroactivePaymentDocuments.length
                  ? _c(
                      "div",
                      { staticClass: "retroactive-payments__empty mt-3" },
                      [
                        _vm._v(
                          " No hay documentos registrados para este pago retroactivo. "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._l(_vm.retroactivePaymentDocuments, function(
                  document,
                  index
                ) {
                  return _c(
                    "div",
                    {
                      key:
                        document.documentId ||
                        `retroactive-payment-document-${index}`,
                      staticClass: "retroactive-payments__document mt-3"
                    },
                    [
                      _c("div", { staticClass: "row align-items-center" }, [
                        _c("div", { staticClass: "col-12 col-md-6" }, [
                          _c(
                            "div",
                            { staticClass: "retroactive-payments__label" },
                            [_vm._v(" Nombre del Documento: ")]
                          ),
                          _c(
                            "div",
                            { staticClass: "retroactive-payments__text" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.documentTypeName(document)) +
                                  " "
                              )
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-12 col-md-5 mt-3 mt-md-0" },
                          [
                            _c(
                              "div",
                              { staticClass: "retroactive-payments__label" },
                              [_vm._v(" Archivo: ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "retroactive-payments__text" },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.documentFilename(document)) +
                                    " "
                                )
                              ]
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-1 text-right mt-3 mt-md-0"
                          },
                          [
                            _c("action-button", {
                              staticClass: "retroactive-payments__download",
                              attrs: {
                                "class-icon": "mr-0",
                                i: "fas fa-file-download",
                                variant: "success"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onDownload(document)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12" }, [
      _c("div", { staticClass: "retroactive-payments__header" }, [
        _c("span", { staticClass: "retroactive-payments__icon" }, [
          _c("em", { staticClass: "fas fa-file-invoice" })
        ]),
        _c("span", { staticClass: "retroactive-payments__title" }, [
          _vm._v(" Consulta de Pagos Retroactivos ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "retroactive-payments__header" }, [
      _c("span", { staticClass: "retroactive-payments__icon" }, [
        _c("em", { staticClass: "fas fa-file-plus" })
      ]),
      _c("span", { staticClass: "retroactive-payments__title" }, [
        _vm._v(" Documentos que sustentan pago retroactivo ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }